import { Link } from "react-router-dom";
import { MessageCircle, Calculator } from "lucide-react";
import { buildWhatsAppLink } from "../../lib/whatsapp";
import { trackWhatsAppClickConversion } from "../../lib/gtag";

export const PageCTA = ({ whatsappNumber, whatsappMessage, ctaCategory, quoteButtonText, whatsappButtonText }) => (
  <div data-testid="page-cta-section" className="flex flex-wrap gap-4">
    <Link
      to="/#cotizador"
      state={ctaCategory ? { presetCategory: ctaCategory } : undefined}
      data-testid="page-cta-quote-button"
      className="flex items-center gap-2 px-8 py-4 bg-twp-gold text-black text-xs uppercase tracking-[0.2em] font-semibold hover:bg-white transition-colors duration-300"
    >
      <Calculator size={16} /> {quoteButtonText || "Cotizar mi evento"}
    </Link>
    {whatsappNumber && (
      <a
        data-testid="page-cta-whatsapp-button"
        href={buildWhatsAppLink(whatsappNumber, whatsappMessage)}
        target="_blank"
        rel="noopener noreferrer"
        onClick={trackWhatsAppClickConversion}
        className="flex items-center gap-2 px-8 py-4 border border-white/30 text-white text-xs uppercase tracking-[0.2em] font-semibold hover:border-twp-gold hover:text-twp-gold transition-colors duration-300"
      >
        <MessageCircle size={16} /> {whatsappButtonText || "Enviar WhatsApp"}
      </a>
    )}
  </div>
);
